import { defineAsyncComponent } from 'vue'
export default {
  "master-layout": defineAsyncComponent(() => import("/opt/atlassian/pipelines/agent/build/layouts/MasterLayout.vue").then(m => m.default || m)),
  "components-master-footer": defineAsyncComponent(() => import("/opt/atlassian/pipelines/agent/build/layouts/components/MasterFooter.vue").then(m => m.default || m)),
  "components-master-header": defineAsyncComponent(() => import("/opt/atlassian/pipelines/agent/build/layouts/components/MasterHeader.vue").then(m => m.default || m))
}